import { client } from '../../apiClient';
import {
  AdminNotificationInput,
  AdminNotificationResponse,
} from '../../../models/admin/notifications/AdminNotification';

const BASE = '/admin/notifications';

export const getAdminNotifications = async (): Promise<AdminNotificationResponse[]> =>
  client(true, true)
    .get<AdminNotificationResponse[]>(BASE)
    .then((response) => response.data);

export const createAdminNotification = async (
  input: AdminNotificationInput
): Promise<AdminNotificationResponse> =>
  client(true, true)
    .post<AdminNotificationResponse>(BASE, input)
    .then((response) => response.data);

export const updateAdminNotification = async (
  id: number,
  input: AdminNotificationInput
): Promise<AdminNotificationResponse> =>
  client(true, true)
    .put<AdminNotificationResponse>(`${BASE}/${id}`, input)
    .then((response) => response.data);

export const deleteAdminNotification = async (id: number): Promise<void> =>
  client(true, true)
    .delete(`${BASE}/${id}`)
    .then(() => undefined);
